// Refus de la préautorisation par la banque (écran 1g).
//
// Stripe renvoie le motif dans `decline_code` (refus bancaire) ou `code`. On
// n'affiche une raison précise que lorsqu'elle aide le client à agir ; les motifs
// liés à la fraude (lost_card, stolen_card, fraudulent…) et les refus sans motif
// (generic_decline, do_not_honor) restent génériques, comme le recommande Stripe.
const REASONS = {
  insufficient_funds: "insufficientFunds",
  card_velocity_exceeded: "insufficientFunds",
  withdrawal_count_limit_exceeded: "insufficientFunds",
  expired_card: "expiredCard",
  incorrect_cvc: "incorrectCvc",
  invalid_cvc: "incorrectCvc",
  payment_intent_authentication_failure: "authentication",
  authentication_required: "authentication",
};

// Stripe peut aussi refuser la carte dès son rattachement au client, côté
// qoREST : l'API répond alors 402 avec son propre code (CARD_DECLINED,
// INSUFFICIENT_FUNDS…).
const API_REASONS = {
  INSUFFICIENT_FUNDS: "insufficientFunds",
  EXPIRED_CARD: "expiredCard",
  INCORRECT_CVC: "incorrectCvc",
  CARD_AUTHENTICATION_FAILED: "authentication",
};

export const refusalReason = (error) =>
  REASONS[error?.decline_code] || REASONS[error?.code] || API_REASONS[error?.data?.code] || "generic";

// Refus de la banque ou 3D Secure non abouti : écran « carte refusée ». Le reste
// (réseau, API, saisie incomplète) reste une erreur affichée sur le formulaire.
export const isCardRefusal = (error) =>
  error?.type === "card_error" ||
  error?.code === "payment_intent_authentication_failure" ||
  (error?.isApiError === true && error?.status === 402);
